import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CompanyComponent from "../components/company_component";
import * as CompanyActions from "../actions";

const mapStateToProps = state => (state.company);

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(CompanyActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyComponent);
